export const routes = {
    home : () => '/',
    auctions: () => '/auctions',
    exchangeConfig: () => '/exchangeconfig',
    etrmConfig: () => '/etrmconfig',
    auctionCalendar: () => '/auctionCalendar',
    profile: () => '/profile',
    support: () => '/support',
    help: () => '/help',
    settings: () => '/settings'
}